export const COUNTRIES = [
  {
    id: 'BE',
    value: 'Belgium',
  },
  {
    id: 'DE',
    value: 'Germany',
  },
  {
    id: 'FR',
    value: 'France',
  },
  {
    id: 'NL',
    value: 'Netherlands',
  },
  {
    id: 'TZ',
    value: 'Tanzania',
  },
  {
    id: 'KE',
    value: 'Kenya',
  },
  {
    id: 'UG',
    value: 'Uganda',
  },
];
